import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/auth';

export const RequireAuth = ({ children }) => {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) {
    return (
      <div className="max-w-md mx-auto mt-24 px-6 text-xs tracking-widest uppercase text-gray-500">
        AUTHENTICATING<span className="caelix-dots"></span>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  }
  return children;
};

export default RequireAuth;
